import React, { useEffect, useState } from 'react';
import { Container, Row, Col, FormInput, FormGroup, Form, Button, FormSelect, Card } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import Input from '../../../components/UI/Input/Input';
import Select from '../../../components/UI/Select/Select';
import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import ImageUploader from '../../../components/UI/ImageUploader/ImageUploader';
import { LinearProgress } from '@material-ui/core';

const AddEstablishment = () => {
  const { submitHandler, resetFormState, loading, field, back } = useForm();
  const { t, i18n } = useTranslation();

  return (
    <>
      {loading && <LinearProgress />}

      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title={t('establishment.title.add')}
            subtitle={t('establishment.subTitle')}
            className="text-sm-left"
          />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4 py-5 px-4">
              <form>
                <Row>
                  <Col md="6">
                    <Input type="text" placeholder={t('placeholder.name')} label={t('label.name')} {...field('name')} />
                  </Col>
                  <Col md="6">
                    <Select placeholder={t('placeholder.category')} label={t('label.category')} {...field('category')}>
                      <option value="" disabled selected>
                        {t('label.category')}
                      </option>
                      <option value="University">{t('label.university')}</option>
                      <option value="School">{t('label.school')}</option>
                      <option value="University_Pole">{t('label.university_Pole')}</option>
                      <option value="Institute">{t('label.institute')}</option>
                    </Select>
                  </Col>

                  <Col md="6">
                    <Select placeholder={t('placeholder.region')} label={t('label.region')} {...field('region')}>
                      <option value="" disabled selected>
                        {t('label.region')}
                      </option>
                      <option value="Est">{t('label.est')}</option>
                      <option value="Ouest">{t('label.ouest')}</option>
                      <option value="Nord">{t('label.nord')}</option>
                      <option value="Sud">{t('label.sud')}</option>
                    </Select>
                  </Col>

                  <Col md="6">
                    <Input type="text" placeholder={t('placeholder.email')} label={t('label.email')} {...field('email')} />
                  </Col>

                  <Col md="6">
                    <Input type="text" placeholder={t('placeholder.phone')} label={t('label.phone')} {...field('phone')} />
                  </Col>
                  <Col md="6"></Col>
                  <Col md="6">
                    <ImageUploader type="file" accept="image/*" {...field('image', 'file')} module="establishment" />
                  </Col>

                  <Col md="12" className="d-flex justify-content-end">
                    <Button theme="info" disabled={loading} onClick={() => back()}>
                      {t('annuler')}
                    </Button>
                    &nbsp; &nbsp;
                    <Button theme="success" type="button" disabled={loading} onClick={() => submitHandler()}>
                      {t('create')}
                    </Button>
                  </Col>
                </Row>
              </form>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddEstablishment;
